var isKind = require('./isKind');
    /**
     */
    function isRegExp(val) {
        return isKind(val, 'RegExp');
    }
    module.exports = isRegExp;




//////////////////
// WEBPACK FOOTER
// ./~/mout/lang/isRegExp.js
// module id = 1611
// module chunks = 0 1 2